import { gql } from '@apollo/client';

export const mutation = gql`
  mutation RemoveTag($id: uuid!) {
    delete_tags_by_pk(id: $id) {
      id
    }
  }
`;

export function buildVariables({ id }) {
  return { id };
}
